// 合并地图
import mergeMap from './mergeMap'
import chinaJson from './json/china.json'
import ganSu from './json/gansu.json'
import linxiaSurround from './json/linxiaSurround.json'
export default {
    chinaJson,
    ganSu,
    ...mergeMap,
    linxiaSurround
}



// WEBPACK FOOTER //
// ./src/assets/geoJson/allGeoJson.js